// Narrowed to the two members `GET /api/patients/text-templates` returns for clinical reports
// (clinical note / discharge note). Kept local: `check-architecture.mjs` forbids one feature from
// importing another.
export enum ClinicalTextTemplateType {
  ClinicalNote = 0,
  DischargeNote = 1,
}

export interface ClinicalTextTemplate {
  readonly id: number;
  readonly title: string;
  readonly text: string;
  readonly type: ClinicalTextTemplateType;
}
